import DataMapper from './DataMapper'
import CaseService from '../../models/CaseService'
import CaseServiceRM from '../responsemodel/CaseServiceRM'

class CaseServiseDataMapper extends DataMapper<CaseServiceRM, CaseService> {
    map = (rm: CaseServiceRM) => new CaseService(rm)
}
export default CaseServiseDataMapper
